"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.modalFooterClassNames = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _Cancel = _interopRequireDefault(require("../../icons/Cancel"));

var _dom = require("../../../helpers/dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var modalFooterClassNames = {
  container: "flex-shrink-0 w-full border-t p-4 md:p-6 flex justify-end"
};
exports.modalFooterClassNames = modalFooterClassNames;

function ModalFooter(_ref) {
  var footerContent = _ref.footerContent,
      actions = _ref.actions,
      classNames = _ref.classNames;
  if (!footerContent && _lodash.default.isEmpty(actions)) return null;
  return _react.default.createElement("div", {
    className: classNames.container
  }, footerContent ? footerContent : _lodash.default.map(actions, function (action) {
    return _react.default.createElement(_Button.default, _extends({
      key: action.label
    }, action));
  }));
}

function Modal(props) {
  var className = props.className,
      style = props.style,
      _props$widthClassName = props.widthClassName,
      widthClassName = _props$widthClassName === void 0 ? 'md:max-w-2xl lg:max-w-3xl' : _props$widthClassName,
      title = props.title,
      headerContent = props.headerContent,
      actions = props.actions,
      footerContent = props.footerContent,
      onClose = props.onClose,
      children = props.children,
      footerClassNames = props.footerClassNames,
      rest = _objectWithoutProperties(props, ["className", "style", "widthClassName", "title", "headerContent", "actions", "footerContent", "onClose", "children", "footerClassNames"]);

  var _useResponsiveLayout = (0, _dom.useResponsiveLayout)(),
      isMobile = _useResponsiveLayout.isMobile;

  var containerClassName = (0, _classnames.default)('relative bg-white w-full m-auto flex-col flex h-full sm:h-auto', className, widthClassName);

  var containerStyle = _objectSpread({
    maxHeight: isMobile ? '100%' : '98%'
  }, style);

  var resolvedFooterClassNames = _objectSpread(_objectSpread({}, modalFooterClassNames), footerClassNames);

  return (0, _reactDom.createPortal)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    "data-testid": "modal-overlay",
    className: "fixed inset-0 z-50 overflow-auto bg-smoke flex",
    onClick: onClose
  }, _react.default.createElement("div", _extends({
    className: containerClassName,
    style: containerStyle,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, rest), title && _react.default.createElement("div", {
    className: "p-4 md:px-6 border-b"
  }, _react.default.createElement("div", {
    className: "flex justify-between items-center"
  }, _react.default.createElement("div", {
    className: "text-xl md:text-2xl font-bold text-off-black"
  }, title), onClose && _react.default.createElement("div", {
    className: "p-3 cursor-pointer"
  }, _react.default.createElement(_Cancel.default, {
    size: 12,
    onClick: onClose,
    className: "cursor-pointer"
  }))), headerContent), _react.default.createElement("div", {
    className: "flex-grow overflow-y-auto overflow-x-hidden"
  }, _react.default.createElement("div", {
    className: "h-full p-4 md:p-6"
  }, children)), _react.default.createElement(ModalFooter, {
    footerContent: footerContent,
    actions: actions,
    classNames: resolvedFooterClassNames
  })))), document.body);
}

Modal.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  onClose: _propTypes.default.func,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired,
    className: _propTypes.default.string
  })),
  headerContent: _propTypes.default.node,
  footerContent: _propTypes.default.node,
  footerClassNames: _propTypes.default.shape({
    container: _propTypes.default.string
  })
};
Modal.defaultProps = {
  className: '',
  actions: [],
  headerContent: null,
  footerContent: null,
  footerClassNames: {}
};

var _default = _react.default.memo(Modal);

exports.default = _default;